import type { PageType } from 'types/page_type';

export const passwordResetPage: Readonly<PageType> = {
  path: '/password/reset',
  title: 'パスワードを変更する',
  description: '組織ユーザーのパスワード設定',
};
